import React, { FC, useState } from 'react';
import LocalModal from 'components/base/local-modal';
import BasicStoreDetails from './basic-store-details';
import FormStepper from 'components/base/form-stepper';
import AddStoreDetailsPreview from './add-store-details-preview';

import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { AddStoreType, initStoreModal, StoreType } from 'models/store.model';
import { CoKitchenType } from 'models/cokitchen.model';
import useDashboardContext from 'contexts/dashboard.context';

type AddStoreItemProps = {
  show: boolean;
  onClose: () => void;
};

const AddStoreModal: FC<AddStoreItemProps> = ({ show, onClose }) => {
  const { setStores, activeCokitchen } = useDashboardContext();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const { cokitchens } = useDashboardContext();
  const [form, setForm] = useState<AddStoreType>(initStoreModal);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const { name, type, logo } = form;
      const cokitchen_id = cokitchens?.find((c: CoKitchenType) => c.name === form.location)?.id;

      await apiService.post(`stores/cokitchen/${cokitchen_id}/stores`, {
        data: {
          name,
          type: type.toUpperCase(),
          logo,
          location: cokitchen_id
        }
      });
      const res = await apiService.get(`stores/cokitchen/${activeCokitchen?.id}/stores`);
      setStores(res.data);
      toast(<ToastMessage message='Store created successfully' type='success' />);
      onClose();

      setForm(initStoreModal);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={() => {
        onClose();
        setForm(initStoreModal);
      }}
      title='Add new store'
      contentClassName='min-w-[770px]'>
      <div>
        <FormStepper
          disabled={form.name === '' || form.type === '' || form.location === ''}
          title=''
          step={step}
          handleConfirmClick={handleConfirm}
          setStep={setStep}
          onNextClick={() => {
            setStep(step + 1);
          }}
          noOfSteps={2}
          loading={loading}>
          <div>
            {step === 1 ? (
              <BasicStoreDetails
                form={form}
                sendValues={(values: Record<keyof StoreType, any>) =>
                  setForm({ ...form, ...values })
                }
              />
            ) : (
              <AddStoreDetailsPreview setStep={setStep} form={form} />
            )}
          </div>
        </FormStepper>
      </div>
    </LocalModal>
  );
};

export default AddStoreModal;
